import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectAxnAdminUserId } from "@utils/parameter-injector";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";

export const getAxnAdminUserRequest = async (axnAdminUserId: string): Promise<{ data: AxnAdminUser, error: any }> => {
    const route = injectAxnAdminUserId(apiRoutes.axnadminCore.data.axnadminuserWithId, axnAdminUserId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};